﻿import React, {Component} from "react";
import PropTypes from 'prop-types';
import {browserHistory, Link} from "react-router";
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { renderTextField } from '../../components/core/editors';

import NavigationBack from "material-ui/svg-icons/navigation/arrow-back";
import QuillEditor from '../../components/core/quill-editor'
import {AppBar, CircularProgress, FlatButton, IconButton, LinearProgress, Paper, RaisedButton, Dialog} from "material-ui";
import service from '../../services/template-services';

class TemplateDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.onBackToList = this.onBackToList.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onDeleteConfirm = this.onDeleteConfirm.bind(this);
        this.handleDeleteClose = this.handleDeleteClose.bind(this);
        this.deleteConfirmed = this.deleteConfirmed.bind(this);

        this.templateId = context.router.params.templateId;
    }

    componentWillMount() {
        this.props.onGet(this.templateId);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    submitForm(data) {

        let preparedData = Object.assign({}, data);
        if(preparedData.Source) {
            preparedData.Source = window.btoa(preparedData.Source)
        }

        this.props.onSubmit(preparedData);
    }

    onDeleteConfirm() {
        this.props.onConfirmDelete(true);
    }

    handleDeleteClose() {
        this.props.onConfirmDelete(false);
    }

    deleteConfirmed() {
        this.props.onDelete(this.templateId);
    }

    onBackToList() {
        browserHistory.goBack();
    }

    render() {

        const { handleSubmit, pristine, submitting, inProgress, saving, openDeleteDialog, dataObject } = this.props;

        if (inProgress) {
            return (
                <div>
                    <AppBar title="Template editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                    />
                    <CircularProgress size={100} thickness={5}/>
                </div>
            )
        }

        let previewStyle = {
            position: "absolute",
            top: "75px",
            right: "5px",
            display: this.templateId > 0 ? "block" : "none",
        };

        let sendStyle = {
            position: "absolute",
            top: "120px",
            right: "5px",
            display: this.templateId > 0 ? "block" : "none",
        };

        const deleteActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onTouchTap={this.handleDeleteClose}
            />,
            <FlatButton
                label="Delete"
                secondary={true}
                keyboardFocused={true}
                onTouchTap={this.deleteConfirmed}
            />,
        ];

        return (
            <div>
                <form onSubmit={handleSubmit(this.submitForm)} noValidate={true} >
                    <AppBar title="Template editor"
                            iconElementLeft={<IconButton onClick={this.onBackToList}><NavigationBack /></IconButton>}
                            iconElementRight={<FlatButton label="Save" type="submit" disabled={pristine || submitting}/>}
                    />

                    <Paper className="template-edit-form" zDepth={1}>
                        { saving ? <LinearProgress mode="indeterminate"/> : null }

                        <RaisedButton style={previewStyle} label="Preview" type="button" containerElement={<Link to={`/template/preview/${dataObject.Id}`}/>}/>
                        <RaisedButton style={sendStyle} label="Send" type="button" containerElement={<Link to={`/template/send/${dataObject.Id}`}/>}/>

                        <Field type="hidden" name="Id" component={renderTextField}/>
                        <Field name="Name" hintText="Template Name" component={renderTextField} floatingLabelText="Template Name" required/>
                        <Field name="Subject" hintText="Subject" component={renderTextField} floatingLabelText="Subject"/>
                        <br/>
                        <br/>
                        <Field name="Source" component={QuillEditor}/>
                        <br/>
                        <br/>
                        <RaisedButton label="Delete" secondary={true} onClick={this.onDeleteConfirm} style={{
                            margin: "auto",
                            marginTop: "50px",
                            marginBottom: "50px",
                            display: this.templateId > 0 ? "block" : "none",
                            width: "150px"
                        }} />
                    </Paper>
                </form>

                <Dialog
                    title="Delete Template?"
                    actions={deleteActions}
                    modal={false}
                    open={openDeleteDialog == undefined ? false : openDeleteDialog}
                    onRequestClose={this.handleDeleteClose}
                >
                    Are you sure you want to delete template?
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => ({...state.templates});

const mapDispatchToProps = dispatch => ({
    onGet: (id) =>
        dispatch({type: 'REQUEST_TEMPLATE', payload: id > 0 ? service.TemplateServices.getTemplate(id) : {
            Id: 0,
            Name: '',
            Source: ''
        }}),
    onSubmit: (role) =>
        dispatch({type: 'SUBMIT_TEMPLATE', payload: service.TemplateServices.postTemplate(role)}),
    onConfirmDelete: (open) =>
        dispatch({type: 'CONFIRM_DELETE_TEMPLATE', payload: open}),
    onDelete: (id) =>
        dispatch({type: 'DELETE_TEMPLATE', payload: service.TemplateServices.deleteTemplate(id)}),
    onUnload: () =>
        dispatch({type: 'TEMPLATE_PAGE_UNLOADED'})
});

const validate = values => {
    const errors = {};
    const requiredFields = [ 'RoleName', 'CountiesAllowed' ];
    requiredFields.forEach(field => {
        if (!values[ field ] && values[field] !== 0) {
            errors[ field ] = 'Required';
        }
    });
    if (isNaN(Number(values.CountiesAllowed))) {
        errors.CountiesAllowed = 'Must be a number'
    } else if (Number(values.CountiesAllowed) < 0) {
        errors.CountiesAllowed = 'Sorry, value must be positive'
    }
    return errors;
};

TemplateDetails.contextTypes = {
    router: PropTypes.any.isRequired
};

TemplateDetails = reduxForm({
    form: 'templateEditForm',
    enableReinitialize: true,
    validate
})(TemplateDetails);

TemplateDetails = connect(mapStateToProps, mapDispatchToProps)(TemplateDetails);

export default TemplateDetails;
